const ZIP_REGEX = /^\d{5}|[a-z]\d[a-z]\d[a-z]\d$/i;

export const plausibleZIP = (zip: string): boolean => ZIP_REGEX.test(zip);
